import { Component, OnInit } from '@angular/core';
import { AuthService, OrganizationService } from '../../services';
import { PropertyStateService } from '../../state/property-state.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-property-sidemenu',
    templateUrl: './property-sidemenu.component.html',
    styleUrls: ['./property-sidemenu.component.scss']
})
export class PropertySidemenuComponent implements OnInit {
    get currentRoute() {
        const urlParts: string[] = this.router.url.split('?')[0].split('/');

        urlParts.pop();

        return urlParts.join('/');
    }

    /**
     * Determines if this is a property that was created by the currently logged in SA.
     */
    get isSAProperty() {
        if (this.auth.userType !== 'SA') {
            return false;
        }

        if (!this.state.property.id) {
            return true;
        }

        return this.state.property.get('owner')?.id === this.auth.currentUser.id;
    }

    constructor(
        public auth: AuthService,
        public state: PropertyStateService,
        public orgService: OrganizationService,
        private router: Router
    ) {}

    ngOnInit() {
    }

    back() {
        const queryParams: string[] = this.router.url.split('?')[1].split('&');
        const referrer: string = queryParams.filter((param: string) => param.startsWith('referrer'))[0];

        if (referrer) {
            void this.router.navigate(['/' + this.orgService.organization.id + '/dashboard/' + referrer.split('=')[1]], {
                queryParams: {},
                replaceUrl: true
            });
        } else {
            void this.router.navigate(['/' + this.orgService.organization.id + '/dashboard/properties'], {
                queryParams: {
                    segment: ''
                },
                queryParamsHandling: 'merge'
            });
        }
    }

}
